import { DuetDatePicker } from "@duetds/date-picker/custom-element";
export let duetDatePickerValidDate = true;
export let isDuetDateValid = true;

export function isDuetDateValidFunction() { return isDuetDateValid; }

global.DatePicker = (function ($) {
	const _isSwedishPage = $('html').is(':lang(sv)');

	// lang sv_SE
	const sv_SE = { buttonLabel: "Välj datum",
	placeholder: "åååå-mm-dd",
	selectedDateMessage: "Valt datum är",
	prevMonthLabel: "Föregående månad",
	nextMonthLabel: "Nästa månad",
	monthSelectLabel: "Månad",
	yearSelectLabel: "År",
	closeLabel: "Stäng datumväljare",
	calendarHeading: "Välj ett datum",
	dayNames: ["söndag", "måndag", "tisdag", "onsdag", "torsdag", "fredag", "lördag"],
	monthNames: ["januari", "februari", "mars", "april", "maj", "juni", "juli", "augusti", "september", "oktober", "november", "december"],
	monthNamesShort: ["Jan", "Feb", "Mar", "Apr", "Maj", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dec"],
	locale: "sv-SE", };

	// lang en_GB
	const en_GB = {
	buttonLabel: "Choose date",
	placeholder: "dd/mm/yyyy",
	selectedDateMessage: "Selected date is",
	prevMonthLabel: "Previous month",
	nextMonthLabel: "Next month",
	monthSelectLabel: "Month",
	yearSelectLabel: "Year",
	closeLabel: "Close window",
	calendarHeading: "Choose a date",
	dayNames: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
	monthNames: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
	monthNamesShort: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
	locale: "en-GB", };

	// inputformat en_GB adapter
	const DATE_FORMAT_en_GB = /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/;

	function setInputFormat_en_GB(pickerId) {
		pickerId.dateAdapter = {
			parse(value = "", createDate) {
			  const matches = value.match(DATE_FORMAT_en_GB)
			  if (matches) {
				return createDate(matches[3], matches[2], matches[1])
			  }
			},
			format(date) {
			  return `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`
			},
		}
	}

	// Date helper Function to add extra hours
	Date.prototype.addHours= function(h){
		this.setHours(this.getHours()+h);
		return this;
	}

	// init
	function init(nonBankingDays) {
		// Datepicker config
		customElements.define("duet-date-picker", DuetDatePicker);

		const datePickerFrom = document.querySelector(".date-picker-from");
		const datePickerTo = document.querySelector(".date-picker-to");
		const formError = document.getElementById("form-error");
		const datePickerFromError = document.getElementById("date-picker-from-error");
		const datePickerToError = document.getElementById("date-picker-to-error");

		// Disable weekends
		function isWeekend(date) {
			if(date != undefined) {
				return date.getDay() === 0 || date.getDay() === 6;
			}
		};

		// Disable nonbankdays (from api)
		function isNonBankDay(date) {
			if(date !== undefined) {
				let timeAdjustedDate = date.addHours(6); // need to add hours to prevent losing a day when running .ISOString() when hours is 00.00
				let onlyDate = timeAdjustedDate.toISOString().slice(0, 10);
				let nonBankingDay = nonBankingDays.indexOf(onlyDate);

				if(nonBankingDay >= 0) {
					return true;
				}
			}
			return false;
		};

		// Disable the dates -> take dates from internal (weekends) and external (non Bank Days)
		function inValidDates(date) {
			return isWeekend(date) || isNonBankDay(date);
		};
		// Handle to date residing in the past.
		function inValidToFrom(fromDate, toDate) {
			const invalidInputs = new Date(fromDate).getTime() > new Date(toDate).getTime();

			if (invalidInputs) {
				formError.classList.remove('visually-hidden');
				return true;
			}

			formError.classList.add('visually-hidden');

			return false;
		}

		function invalidDatesFromInputs() {
			const dateFrom = new Date(datePickerFrom.value);
			const dateTo = new Date(datePickerTo.value);
			const invalidDateFrom = isWeekend(dateFrom) || isNonBankDay(dateFrom);
			const invalidDateTo = isWeekend(dateTo) || isNonBankDay(dateTo);

			if (invalidDateFrom && invalidDateTo) {
				datePickerFromError.classList.remove("visually-hidden");
				datePickerToError.classList.remove("visually-hidden");
				return true;
			}

			if (invalidDateFrom || invalidDateTo) {
				if (invalidDateFrom) {
					datePickerToError.classList.add("visually-hidden");
					datePickerFromError.classList.remove("visually-hidden");
				}

				if (invalidDateTo) {
					datePickerToError.classList.remove("visually-hidden");
					datePickerFromError.classList.add("visually-hidden");
				}

				return true;
			}

			datePickerFromError.classList.add("visually-hidden");
			datePickerToError.classList.add("visually-hidden");

			return false;
		}

		function validateField(event, pickerMin) {
			formError.classList.add("visually-hidden");
			isDuetDateValid = true;

			if (inValidToFrom(datePickerFrom.value, datePickerTo.value) && (invalidDatesFromInputs() || (event.detail.valueAsDate < pickerMin || event.detail.valueAsDate == undefined))) {
				isDuetDateValid = false;
				return;
			}

			if (inValidToFrom(datePickerFrom.value, datePickerTo.value) && (!invalidDatesFromInputs() || (event.detail.valueAsDate < pickerMin || event.detail.valueAsDate == undefined))) {
				isDuetDateValid = false;
				return;
			}

			if (!inValidToFrom(datePickerFrom.value, datePickerTo.value) && (invalidDatesFromInputs() || (event.detail.valueAsDate < pickerMin || event.detail.valueAsDate == undefined))) {
				isDuetDateValid = false;
				return;
			}
		}

		// Set up events, min, max and inputlanguage
		if (datePickerFrom || datePickerTo) {
			const datePickerFromMin = new Date(datePickerFrom.dataset.minYear);
			const datePickerToMin = new Date(datePickerFrom.dataset.minYear);

			// datePickerFrom
			datePickerFrom.addEventListener("duetChange", function (e) {
				validateField(e, datePickerFromMin);
			});

			// datePickerTo
			datePickerTo.addEventListener("duetChange", function (e) {
				validateField(e, datePickerToMin);
			});

			// Set inputlanguage
			if(_isSwedishPage) {
				datePickerFrom.localization = sv_SE;
				datePickerTo.localization = sv_SE;
			} else {
				datePickerFrom.localization = en_GB;
				datePickerTo.localization = en_GB;
				setInputFormat_en_GB(datePickerFrom);
				setInputFormat_en_GB(datePickerTo);
			}

			// Disable dates in picker
			datePickerFrom.isDateDisabled = inValidDates;
			datePickerTo.isDateDisabled = inValidDates;
		}

	}

	function initFromTo(nonBankingDaysFrom, nonBankingDaysTo) {
		if (!customElements.get("duet-date-picker")) {
			customElements.define("duet-date-picker", DuetDatePicker);
		}

		const datePickerFrom = document.querySelector(".date-picker-from");
		const datePickerTo = document.querySelector(".date-picker-to");
		const formError = document.getElementById("form-error");
		const datePickerFromError = document.getElementById("date-picker-from-error");
		const datePickerToError = document.getElementById("date-picker-to-error");

		// Disable weekends
		function isWeekend(date) {
			if (date != undefined) {
				return date.getDay() === 0 || date.getDay() === 6;
			}
		};

		// Disable nonbankdays (from api)
		function isNonBankDayFrom(date) {
			if (date !== undefined) {
				let timeAdjustedDate = date.addHours(6); // need to add hours to prevent losing a day when running .ISOString() when hours is 00.00
				let onlyDate = timeAdjustedDate.toISOString().slice(0, 10);
				let nonBankingDay = nonBankingDaysFrom.indexOf(onlyDate);

				if (nonBankingDay >= 0) {
					return true;
				}
			}
			return false;
		};

		function isNonBankDayTo(date) {
			if (date !== undefined) {
				let timeAdjustedDate = date.addHours(6); // need to add hours to prevent losing a day when running .ISOString() when hours is 00.00
				let onlyDate = timeAdjustedDate.toISOString().slice(0, 10);
				let nonBankingDay = nonBankingDaysTo.indexOf(onlyDate);

				if (nonBankingDay >= 0) {
					return true;
				}
			}
			return false;
		};

		// Disable the dates -> take dates from internal (weekends) and external (non Bank Days)
		function inValidDatesFrom(date) {
			return isWeekend(date) || isNonBankDayFrom(date);
		};
		function inValidDatesTo(date) {
			return isWeekend(date) || isNonBankDayTo(date);
		};
		// Handle to date residing in the past.
		function inValidToFrom(fromDate, toDate) {
			const invalidInputs = new Date(fromDate).getTime() > new Date(toDate).getTime();

			if (invalidInputs) {
				formError.classList.remove('visually-hidden');
				return true;
			}

			formError.classList.add('visually-hidden');

			return false;
		}

		function invalidDatesFromInputs() {
			const dateFrom = new Date(datePickerFrom.value);
			const dateTo = new Date(datePickerTo.value);
			const invalidDateFrom = isWeekend(dateFrom) || isNonBankDayFrom(dateFrom);
			const invalidDateTo = isWeekend(dateTo) || isNonBankDayTo(dateTo);

			if (invalidDateFrom && invalidDateTo) {
				datePickerFromError.classList.remove("visually-hidden");
				datePickerToError.classList.remove("visually-hidden");
				return true;
			}

			if (invalidDateFrom || invalidDateTo) {
				if (invalidDateFrom) {
					datePickerToError.classList.add("visually-hidden");
					datePickerFromError.classList.remove("visually-hidden");
				}

				if (invalidDateTo) {
					datePickerToError.classList.remove("visually-hidden");
					datePickerFromError.classList.add("visually-hidden");
				}

				return true;
			}

			datePickerFromError.classList.add("visually-hidden");
			datePickerToError.classList.add("visually-hidden");

			return false;
		}

		function validateField(event, pickerMin) {
			formError.classList.add("visually-hidden");
			isDuetDateValid = true;

			if (inValidToFrom(datePickerFrom.value, datePickerTo.value) && (invalidDatesFromInputs() || (event.detail.valueAsDate < pickerMin || event.detail.valueAsDate == undefined))) {
				isDuetDateValid = false;
				return;
			}

			if (inValidToFrom(datePickerFrom.value, datePickerTo.value) && (!invalidDatesFromInputs() || (event.detail.valueAsDate < pickerMin || event.detail.valueAsDate == undefined))) {
				isDuetDateValid = false;
				return;
			}

			if (!inValidToFrom(datePickerFrom.value, datePickerTo.value) && (invalidDatesFromInputs() || (event.detail.valueAsDate < pickerMin || event.detail.valueAsDate == undefined))) {
				isDuetDateValid = false;
				return;
			}
		}

		// Set up events, min, max and inputlanguage
		if (datePickerFrom || datePickerTo) {
			const datePickerFromMin = new Date(datePickerFrom.dataset.minYear);
			const datePickerToMin = new Date(datePickerFrom.dataset.minYear);

			// datePickerFrom
			datePickerFrom.addEventListener("duetChange", function (e) {
				validateField(e, datePickerFromMin);
			});

			// datePickerTo
			datePickerTo.addEventListener("duetChange", function (e) {
				validateField(e, datePickerToMin);
			});

			// Set inputlanguage
			if (_isSwedishPage) {
				datePickerFrom.localization = sv_SE;
				datePickerTo.localization = sv_SE;
			} else {
				datePickerFrom.localization = en_GB;
				datePickerTo.localization = en_GB;
				setInputFormat_en_GB(datePickerFrom);
				setInputFormat_en_GB(datePickerTo);
			}

			// Disable dates in picker
			datePickerFrom.isDateDisabled = inValidDatesFrom;
			datePickerTo.isDateDisabled = inValidDatesTo;
		}
	}

	return {
		init: init,
		initFromTo: initFromTo
	};

})(jQuery);
